import React from "react";
import { Box, Button, Tooltip } from "@mui/material";
import AppleIcon from "@mui/icons-material/Apple";
import AndroidIcon from "@mui/icons-material/Android";
import { APP_STORE_URL, PLAY_STORE_URL } from "../../utils/appDownloadLinks";

const buttonBaseSx = {
  textTransform: "none",
  borderRadius: "10px",
  fontWeight: 700,
  px: 1.75,
  py: 1,
  minHeight: "44px",
  lineHeight: 1.1,
  boxShadow: "0 10px 24px rgba(0,0,0,0.12)",
};

function StoreButton({ href, icon, topText, bottomText, colorScheme }) {
  const isEnabled = Boolean(href);
  const isDark = colorScheme === "dark";

  const button = (
    <Button
      component={isEnabled ? "a" : "button"}
      href={isEnabled ? href : undefined}
      target={isEnabled ? "_blank" : undefined}
      rel={isEnabled ? "noopener noreferrer" : undefined}
      disabled={!isEnabled}
      startIcon={icon}
      variant="contained"
      sx={{
        ...buttonBaseSx,
        background: isDark ? "linear-gradient(180deg, #0B0B0B 0%, #000 100%)" : "linear-gradient(180deg, #FFFFFF 0%, #F5F5F5 100%)",
        color: isDark ? "#fff" : "#000",
        border: `1px solid ${isDark ? "rgba(255,255,255,0.12)" : "rgba(0,0,0,0.10)"}`,
        "&:hover": {
          background: isDark ? "linear-gradient(180deg, #141414 0%, #050505 100%)" : "linear-gradient(180deg, #FFFFFF 0%, #EEEEEE 100%)",
          boxShadow: "0 14px 28px rgba(0,0,0,0.16)",
        },
        "&.Mui-disabled": {
          opacity: 0.55,
          color: isDark ? "#fff" : "#000",
          boxShadow: "none",
        },
        "& .MuiButton-startIcon": {
          marginRight: "10px",
        },
      }}
      aria-label={isEnabled ? `${bottomText} (opens in a new tab)` : `${bottomText} (link not set)`}
    >
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
        <Box component="span" sx={{ fontSize: "11px", fontWeight: 600, opacity: 0.9 }}>
          {topText}
        </Box>
        <Box component="span" sx={{ fontSize: "15px", fontWeight: 900, letterSpacing: "-0.2px" }}>
          {bottomText}
        </Box>
      </Box>
    </Button>
  );

  if (isEnabled) return button;

  return (
    <Tooltip title="Download link not set yet">
      <Box component="span">{button}</Box>
    </Tooltip>
  );
}

export default function AppDownloadButtons({
  colorScheme = "dark",
  align = "flex-start",
  justify = "flex-start",
  gap = "10px",
  sx,
}) {
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: align,
        justifyContent: justify,
        gap,
        ...sx,
      }}
    >
      <StoreButton
        href={APP_STORE_URL}
        icon={<AppleIcon />}
        topText="Download on the"
        bottomText="App Store"
        colorScheme={colorScheme}
      />
      <StoreButton
        href={PLAY_STORE_URL}
        icon={<AndroidIcon />}
        topText="Get it on"
        bottomText="Google Play"
        colorScheme={colorScheme}
      />
    </Box>
  );
}
